import React, { useState } from "react";
import "../css/RetainDeleteArea.css";

const RetainDeleteArea = () => {
  const [formData, setFormData] = useState({
    retainedState: "MADHYA PRADESH",
    retainedCity: "",
    retainedArea: "",
    deletedState: "MADHYA PRADESH",
    deletedCity: "ALIRAJPUR",
    deletedArea: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.retainedCity || !formData.retainedArea || !formData.deletedArea || !formData.password) {
      alert("Please fill all required fields");
      return;
    }
    alert("Form submitted");
  };

  return (
    <div className="employee-main-container">
      <div className="employee-content-container">
        <div className="employee-heading-container">
          <h2 className="employee-title">Retain / Delete Area</h2>
        </div>

        <form onSubmit={handleSubmit} className="retain-delete-form">
          <fieldset className="retain-delete-fieldset">
            <legend className="retain-delete-legend">
              Delete City ( All Data Will Be transferred to Retained City. Use It carefully )
            </legend>

            <div className="retain-delete-grid">
              {/* Retained Section */}
              <div className="retain-delete-group">
                <label>RETAINED STATE</label>
                <select name="retainedState" value={formData.retainedState} onChange={handleChange}>
                  <option value="MADHYA PRADESH">MADHYA PRADESH</option>
                  <option value="PUNJAB">PUNJAB</option>
                </select>
              </div>

              <div className="retain-delete-group">
                <label>RETAINED CITY</label>
                <select name="retainedCity" value={formData.retainedCity} onChange={handleChange} required>
                  <option value="">Select</option>
                  <option value="ALIRAJPUR">ALIRAJPUR</option>
                </select>
              </div>

              <div className="retain-delete-group">
                <label>RETAINED AREA</label>
                <select name="retainedArea" value={formData.retainedArea} onChange={handleChange} required>
                  <option value="">Select</option>
                </select>
              </div>

              {/* Deleted Section */}
              <div className="retain-delete-group">
                <label>DELETED STATE</label>
                <select name="deletedState" value={formData.deletedState} onChange={handleChange}>
                  <option value="MADHYA PRADESH">MADHYA PRADESH</option>
                </select>
              </div>

              <div className="retain-delete-group">
                <label>DELETED CITY</label>
                <select name="deletedCity" value={formData.deletedCity} onChange={handleChange}>
                  <option value="ALIRAJPUR">ALIRAJPUR</option>
                </select>
              </div>

              <div className="retain-delete-group">
                <label>DELETED AREA</label>
                <select name="deletedArea" value={formData.deletedArea} onChange={handleChange} required>
                  <option value="">Select</option>
                  <option value="40500">Ajad Nagar 40500</option>
                  <option value="32913">Alirajpur Local 32913</option>
                </select>
              </div>

              {/* Password & GO Button */}
              <div className="retain-delete-group col-span-2">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="retain-delete-group button-wrapper">
                <button type="submit" className="retain-delete-button">GO</button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>

    </div>
  );
};

export default RetainDeleteArea;
